import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export enum BusinessStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
  ARCHIVED = 'archived',
}

export const businessStatusMap: Record<BusinessStatus, MapItem> = {
  active: { label: 'Active' },
  inactive: { label: 'Inactive' },
  pending: { label: 'Pending' },
  archived: { label: 'Archived' },
}

export const businessStatusArray = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
  { label: 'Pending', value: 'pending' },
  { label: 'Archived', value: 'archived' },
]

export const businessStatusSchema = z.nativeEnum(BusinessStatus)

export type BusinessStatusType = 'active' | 'inactive' | 'pending' | 'archived'
